// Landing-page hero photos come in three sizes (public/landing/<name>-640.jpg,
// -960.jpg and the 1400px original). A phone on mobile data takes the 960px one
// (about 40% of the original's bytes) instead of the full 1400px photo, which is
// what the first paint was waiting behind.
export function heroSrcSet(src) {
  const base = src.replace(/\.jpg$/, "");
  return `${base}-640.jpg 640w, ${base}-960.jpg 960w, ${src} 1400w`;
}
